export default {
    async new({ commit, dispatch }) {
        commit('new')
    }
}
